import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : undefined, withCredentials: true });

export const hasBackend = Boolean(BASE);

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (!err?.response) return "We couldn't reach our server. Please check your connection and try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: id === "home" ? 0 : -64, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
}
